import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import { writeLeadsMapLastView } from "../../utils/leadsMapInitialView";

const SAVE_DEBOUNCE_MS = 750;

/**
 * Persists map center + zoom in localStorage per user (all roles).
 */
export default function MapLastViewPersistence({ enabled, userId }) {
  const map = useMap();
  const timerRef = useRef(null);

  useEffect(() => {
    if (!enabled || userId == null || userId === "" || !map) return;

    const scheduleSave = () => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        try {
          const c = map.getCenter();
          writeLeadsMapLastView(userId, [c.lat, c.lng], map.getZoom());
        } catch {
          /* ignore */
        }
      }, SAVE_DEBOUNCE_MS);
    };

    map.on("moveend", scheduleSave);
    map.on("zoomend", scheduleSave);
    return () => {
      map.off("moveend", scheduleSave);
      map.off("zoomend", scheduleSave);
      clearTimeout(timerRef.current);
    };
  }, [enabled, userId, map]);

  return null;
}
